// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"27bdbacb","856":"8b6d20c2"}[chunkId] + ".js";
};